export class RequestResetPasswordModel {
	Username: string;
	DatabaseName: string;
}